<div class="dashboard-date-range-filter" [class.dashboard-date-range-filter-sm]="sm">
  <select
    class="form-control form-select period-selector"
    [class.form-control-sm]="sm"
    [disabled]="disabled"
    [ngModel]="period"
    (ngModelChange)="periodChange($event)">
    <option *ngFor="let option of periodOptions" [ngValue]="option.key">
      {{option.value|translate}}
    </option>
  </select>

  <ng-container *ngIf="period === DashboardPeriod.Custom; else selectedDateRange">
    <div class="date-field">
      <input
        type="text"
        autocomplete="off"
        class="form-control"
        [class.form-control-sm]="sm"
        [id]="id + '-from'"
        [disabled]="disabled"
        [maxlength]="10"
        [ngClass]="{'is-invalid': !fromIsValid(), 'ng-valid': fromDate && fromIsValid()}"
        [placeholder]="'datetime.date'|translate"
        [(ngModel)]="fromDate"
        (ngModelChange)="dateChange()"
        ngbDatepicker
        #fromPicker="ngbDatepicker">
      <button
        type="button"
        tabindex="-1"
        class="btn btn-light"
        [class.btn-sm]="sm"
        [disabled]="disabled"
        (click)="fromPicker.toggle()">
        <i class="fa fa-calendar"></i>
      </button>
    </div>

    <span class="range-separator">t/m</span>

    <div class="date-field">
      <input
        type="text"
        autocomplete="off"
        class="form-control"
        [class.form-control-sm]="sm"
        [id]="id + '-to'"
        [disabled]="disabled"
        [maxlength]="10"
        [ngClass]="{'is-invalid': !toIsValid() || (fromIsValid() && toIsValid() && fromDate && toDate && !rangeValid()), 'ng-valid': toDate && toIsValid() && rangeValid()}"
        [placeholder]="'datetime.date'|translate"
        [(ngModel)]="toDate"
        (ngModelChange)="dateChange()"
        ngbDatepicker
        #toPicker="ngbDatepicker">
      <button
        type="button"
        tabindex="-1"
        class="btn btn-light"
        [class.btn-sm]="sm"
        [disabled]="disabled"
        (click)="toPicker.toggle()">
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </ng-container>

  <ng-template #selectedDateRange>
    <span class="selected-date-range">
      ({{fromDate}}<ng-container *ngIf="fromDate !== toDate"> t/m {{toDate}}</ng-container>)
    </span>
  </ng-template>
</div>
